(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    if (!window.noboProfessionalMenuBound) {
    window.noboProfessionalMenuBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-nobo-professional-trigger]');
      if (!trigger) return;

      const drawer = trigger.closest('header-drawer');
      const targetId = trigger.dataset.noboProfessionalTarget;
      const summary = drawer?.querySelector(`#${CSS.escape(targetId)} > summary`);
      summary?.click();
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-size-variants"] && !Shopify.designMode) return;
  try {
    class ProductCardSizeVariants extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.addEventListener('click', this.handleSizeSelection);
    }

    handleSizeSelection = (event) => {
      const option = event.target.closest('[data-card-size-option]');
      if (!(option instanceof HTMLButtonElement) || option.disabled) return;

      event.preventDefault();
      event.stopPropagation();

      this.querySelectorAll('[data-card-size-option]').forEach((sizeOption) => {
        sizeOption.setAttribute('aria-pressed', sizeOption === option ? 'true' : 'false');
      });

      const variantInput = this.querySelector('[data-card-size-variant-id]');
      const actionButton = this.querySelector('[ref="addToCartButton"]');
      const actionLabel = this.querySelector('[data-card-size-action-label]');
      const addToCart = this.querySelector('add-to-cart-component');

      if (!(variantInput instanceof HTMLInputElement) || !(actionButton instanceof HTMLButtonElement)) return;

      variantInput.value = option.dataset.variantId || '';
      variantInput.disabled = variantInput.value === '';
      actionButton.disabled = variantInput.disabled;

      if (actionLabel) actionLabel.textContent = this.dataset.addToCartLabel || '';
      if (addToCart && option.dataset.variantMedia) {
        addToCart.dataset.productVariantMedia = option.dataset.variantMedia;
      }

      const productPrice = this.closest('product-card')?.querySelector('.product-card__content > product-price');
      const currentPrice = productPrice?.querySelector('[ref="priceContainer"]');
      const salePriceFirst = Boolean(
        currentPrice?.querySelector('.price__sale > .price-item__group:first-of-type .price-item--sale')
      );
      const priceTemplate = Array.from(this.querySelectorAll('template[data-card-size-price-template]')).find(
        (template) =>
          template.dataset.cardSizePriceTemplate === option.dataset.priceTemplateKey &&
          template.dataset.salePriceFirst === String(salePriceFirst)
      );

      if (priceTemplate instanceof HTMLTemplateElement && currentPrice) {
        const newPrice = priceTemplate.content.querySelector('[ref="priceContainer"]')?.cloneNode(true);
        if (newPrice instanceof HTMLElement) currentPrice.replaceWith(newPrice);
      }

      const productCard = this.closest('product-card');
      const productTemplate = Array.from(this.querySelectorAll('template[data-card-size-product-template]')).find(
        (template) => template.dataset.cardSizeProductTemplate === option.dataset.productTemplateKey
      );

      if (!(productCard instanceof HTMLElement) || !(productTemplate instanceof HTMLTemplateElement)) return;

      const productTitle = productTemplate.dataset.productTitle || '';
      const productUrl = productTemplate.dataset.productUrl || '';
      const productCardLink = productCard.querySelector(':scope > .product-card__link');
      const cardGalleryLink = productCard.querySelector('[ref="cardGalleryLink"]');
      const productTitleLink = productCard.querySelector('[ref="productTitleLink"]');

      [productCardLink, cardGalleryLink, productTitleLink].forEach((link) => {
        if (link instanceof HTMLAnchorElement && productUrl) link.href = productUrl;
      });

      const hiddenTitle = productCardLink?.querySelector('.visually-hidden');
      const visibleTitle = productTitleLink?.querySelector('[role="heading"], h1, h2, h3, h4, h5, h6');
      const zoomOutTitle = productCard.querySelector('.product-grid-view-zoom-out--details h3');

      if (hiddenTitle && productTitle) hiddenTitle.textContent = productTitle;
      if (visibleTitle && productTitle) visibleTitle.textContent = productTitle;
      if (zoomOutTitle && productTitle) zoomOutTitle.textContent = productTitle;
      if (cardGalleryLink instanceof HTMLAnchorElement && productTitle) {
        cardGalleryLink.setAttribute('aria-label', productTitle);
      }

      const mediaTemplates = Array.from(productTemplate.content.querySelectorAll('[data-card-size-media]'));
      const cardImages = Array.from(cardGalleryLink?.querySelectorAll('.product-media__image') || []);
      const imageAttributes = ['src', 'srcset', 'alt', 'width', 'height', 'data-max-resolution', 'style'];
      const selectedPrimaryImage = mediaTemplates[0]?.querySelector('.product-media__image');

      if (selectedPrimaryImage instanceof HTMLImageElement) {
        const featuredMediaUrl = selectedPrimaryImage.getAttribute('data-max-resolution');
        if (featuredMediaUrl) productCard.dataset.featuredMediaUrl = featuredMediaUrl;
      }

      cardImages.forEach((cardImage, index) => {
        const mediaTemplate = mediaTemplates[index];
        const templateImage = mediaTemplate?.querySelector('.product-media__image');
        const slide = cardImage.closest('slideshow-slide');

        if (!(templateImage instanceof HTMLImageElement) || !(mediaTemplate instanceof HTMLElement)) {
          if (slide) slide.hidden = true;
          return;
        }

        imageAttributes.forEach((attribute) => {
          const value = templateImage.getAttribute(attribute);
          if (value === null) cardImage.removeAttribute(attribute);
          else cardImage.setAttribute(attribute, value);
        });

        const productMedia = cardImage.closest('.product-media');
        if (productMedia instanceof HTMLElement) {
          productMedia.dataset.mediaId = mediaTemplate.dataset.mediaId || '';
          productMedia.style.setProperty('--ratio', mediaTemplate.dataset.aspectRatio || '1');
        }

        if (slide) {
          slide.hidden = false;
          slide.setAttribute('slide-id', mediaTemplate.dataset.mediaId || '');
        }
      });
    };
  }

  if (!customElements.get('product-card-size-variants')) {
    customElements.define('product-card-size-variants', ProductCardSizeVariants);
  }
  } catch(e) { console.error(e); }
})();

})();
